import { Switch as MaterialSwitch } from '@mui/material';
import React from 'react';

import { SwitchProps } from './Switch.props';
import { ColorProps, SizeProps } from '../../../@types/common.type';

export const Switch: React.FC<SwitchProps> = ({
  defaultChecked = false,
  checked = false,
  color = ColorProps.Default,
  size= SizeProps.Small,
  onChange,
  onClick,
  disabled,
  testDataId
}) => {
  return (
    <MaterialSwitch 
      defaultChecked={defaultChecked} 
      checked={checked} 
      color={color}
      size={size}
      onChange={onChange}
      onClick={onClick}
      disabled={disabled}
      inputProps={{
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        'data-testid': testDataId,
      }}
    />);
};